export default function (Alpine) {
    if (!window.Livewire) {
        return
    }

    Alpine.magic("wire", function (el) {
        let wireEl = el.closest("[wire\\:id]")

        if (!wireEl) {
            console.warn(
                'Alpine: Cannot reference "$wire" outside a Livewire component.'
            )
            return
        }

        let component = wireEl.__livewire

        return component.$wire
    })

    Alpine.magic("wireWatch", function ($el, { Alpine }) {
        let wireEl = $el.closest("[wire\\:id]")

        if (!wireEl) {
            console.warn(
                'Alpine: Cannot reference "$wireWatch" outside a Livewire component.'
            )
            return
        }

        let component = wireEl.__livewire

        return function (property, callback) {
            component.watch(property, callback)
        }
    })
}
